import {BaseError} from './base-error';

export class GeneralBackendError extends BaseError {
    constructor (public message: string, public description?: string, public code?: string) {
        super(message, description, code);
    }
}
